export class ClaimAddCommand{
    identity:string;
    claim:string;

    constructor(identity:string,claim:string){
        this.identity = identity;
        this.claim = claim;
    }
}